import { render, staticRenderFns } from "./SpendingStatistics.vue?vue&type=template&id=6d3d66b8&scoped=true&"
import script from "./SpendingStatistics.vue?vue&type=script&lang=js&"
export * from "./SpendingStatistics.vue?vue&type=script&lang=js&"
import style0 from "./SpendingStatistics.vue?vue&type=style&index=0&id=6d3d66b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3d66b8",
  null
  
)

export default component.exports